import { createAction } from "@reduxjs/toolkit";
import type { UpdateStudentSettingsBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export interface UpdateStudentSettingsParams {
  studentId: string;
  body: UpdateStudentSettingsBody;
}

export const updateStudentSettings = createApiThunk<string, UpdateStudentSettingsParams>(
  "admin/students/updateSettings",
  async ({ studentId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateStudentSettings(studentId, body);
    return studentId;
  },
);

export const resetUpdateStudentSettings = createAction("admin/students/resetUpdateSettings");
